module.exports = __webpack_public_path__ + "assets/support-icon.608f640d.svg";